import { render, staticRenderFns } from "./GeneralFareManagement.vue?vue&type=template&id=b4117eec&"
import script from "./GeneralFareManagement.vue?vue&type=script&lang=js&"
export * from "./GeneralFareManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports